import './style.css';
import React from "react";

function Interview() {
    
    return (
        <div className="interview">
            <h1>None</h1>
        </div>
    );
}
    
export default Interview;

